/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type {
  NotificationItem,
  NotificationPanelInfo,
  NotificationPatchModel,
  NotificationsByEntitiesListResponse,
  NotificationsGroupedNotificationsGetV2Params,
} from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 * @summary Returns a cursor based, paginated response containing notifications grouped by entitiy
 */
export const notificationsGroupedNotificationsGetV2 = (
  params: NotificationsGroupedNotificationsGetV2Params,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<NotificationsByEntitiesListResponse>(
    {
      url: `/apix/v2/Notifications/grouped-notifications`,
      method: "GET",
      params,
      signal,
    },
    options,
  );
};

export const getNotificationsGroupedNotificationsGetV2QueryKey = (
  params?: NotificationsGroupedNotificationsGetV2Params,
) => {
  return [
    `/apix/v2/Notifications/grouped-notifications`,
    ...(params ? [params] : []),
  ] as const;
};

export const getNotificationsGroupedNotificationsGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof notificationsGroupedNotificationsGetV2>>,
  TError = ErrorType<unknown>,
>(
  params: NotificationsGroupedNotificationsGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof notificationsGroupedNotificationsGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getNotificationsGroupedNotificationsGetV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof notificationsGroupedNotificationsGetV2>>
  > = ({ signal }) =>
    notificationsGroupedNotificationsGetV2(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof notificationsGroupedNotificationsGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type NotificationsGroupedNotificationsGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof notificationsGroupedNotificationsGetV2>>
>;
export type NotificationsGroupedNotificationsGetV2QueryError =
  ErrorType<unknown>;

/**
 * @summary Returns a cursor based, paginated response containing notifications grouped by entitiy
 */

export function useNotificationsGroupedNotificationsGetV2<
  TData = Awaited<ReturnType<typeof notificationsGroupedNotificationsGetV2>>,
  TError = ErrorType<unknown>,
>(
  params: NotificationsGroupedNotificationsGetV2Params,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof notificationsGroupedNotificationsGetV2>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getNotificationsGroupedNotificationsGetV2QueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const notificationsMarkAllReadPutV2 = (
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<void>(
    { url: `/apix/v2/Notifications/mark-all-read`, method: "PUT" },
    options,
  );
};

export const getNotificationsMarkAllReadPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsMarkAllReadPutV2>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof notificationsMarkAllReadPutV2>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["notificationsMarkAllReadPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof notificationsMarkAllReadPutV2>>,
    void
  > = () => {
    return notificationsMarkAllReadPutV2(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsMarkAllReadPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof notificationsMarkAllReadPutV2>>
>;

export type NotificationsMarkAllReadPutV2MutationError = ErrorType<unknown>;

export const useNotificationsMarkAllReadPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsMarkAllReadPutV2>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof notificationsMarkAllReadPutV2>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getNotificationsMarkAllReadPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const notificationsByNotificationIdPatchV2 = (
  notificationId: number,
  notificationPatchModel: BodyType<NotificationPatchModel>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<NotificationItem>(
    {
      url: `/apix/v2/Notifications/${notificationId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: notificationPatchModel,
    },
    options,
  );
};

export const getNotificationsByNotificationIdPatchV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsByNotificationIdPatchV2>>,
    TError,
    { notificationId: number; data: BodyType<NotificationPatchModel> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof notificationsByNotificationIdPatchV2>>,
  TError,
  { notificationId: number; data: BodyType<NotificationPatchModel> },
  TContext
> => {
  const mutationKey = ["notificationsByNotificationIdPatchV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof notificationsByNotificationIdPatchV2>>,
    { notificationId: number; data: BodyType<NotificationPatchModel> }
  > = (props) => {
    const { notificationId, data } = props ?? {};

    return notificationsByNotificationIdPatchV2(
      notificationId,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsByNotificationIdPatchV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof notificationsByNotificationIdPatchV2>>
>;
export type NotificationsByNotificationIdPatchV2MutationBody =
  BodyType<NotificationPatchModel>;
export type NotificationsByNotificationIdPatchV2MutationError =
  ErrorType<unknown>;

export const useNotificationsByNotificationIdPatchV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsByNotificationIdPatchV2>>,
    TError,
    { notificationId: number; data: BodyType<NotificationPatchModel> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof notificationsByNotificationIdPatchV2>>,
  TError,
  { notificationId: number; data: BodyType<NotificationPatchModel> },
  TContext
> => {
  const mutationOptions =
    getNotificationsByNotificationIdPatchV2MutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const notificationsPanelInfoGetV2 = (
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<NotificationPanelInfo>(
    { url: `/apix/v2/Notifications/panel-info`, method: "GET", signal },
    options,
  );
};

export const getNotificationsPanelInfoGetV2QueryKey = () => {
  return [`/apix/v2/Notifications/panel-info`] as const;
};

export const getNotificationsPanelInfoGetV2QueryOptions = <
  TData = Awaited<ReturnType<typeof notificationsPanelInfoGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof notificationsPanelInfoGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getNotificationsPanelInfoGetV2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof notificationsPanelInfoGetV2>>
  > = ({ signal }) => notificationsPanelInfoGetV2(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof notificationsPanelInfoGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type NotificationsPanelInfoGetV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof notificationsPanelInfoGetV2>>
>;
export type NotificationsPanelInfoGetV2QueryError = ErrorType<unknown>;

export function useNotificationsPanelInfoGetV2<
  TData = Awaited<ReturnType<typeof notificationsPanelInfoGetV2>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof notificationsPanelInfoGetV2>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getNotificationsPanelInfoGetV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const notificationsPanelInfoPutV2 = (
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<NotificationPanelInfo>(
    { url: `/apix/v2/Notifications/panel-info`, method: "PUT" },
    options,
  );
};

export const getNotificationsPanelInfoPutV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsPanelInfoPutV2>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof notificationsPanelInfoPutV2>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["notificationsPanelInfoPutV2"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof notificationsPanelInfoPutV2>>,
    void
  > = () => {
    return notificationsPanelInfoPutV2(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsPanelInfoPutV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof notificationsPanelInfoPutV2>>
>;

export type NotificationsPanelInfoPutV2MutationError = ErrorType<unknown>;

export const useNotificationsPanelInfoPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof notificationsPanelInfoPutV2>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof notificationsPanelInfoPutV2>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getNotificationsPanelInfoPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
